import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom-v5-compat";

import {
  getPasswordResets,
  passwordsResetSuccessReset
} from "seneca-common/features/teachers/state";

import { showResetPasswordsToast } from "./ResetPasswordsToast";

export default function useShowResetPasswordsToast() {
  const { success, userIds, schoolId } = useSelector(getPasswordResets);
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (success !== null && !searchParams.has("reset")) {
      showResetPasswordsToast({
        success: success!,
        userIds,
        onClose: () => dispatch(passwordsResetSuccessReset()),
        schoolId
      });
    }
  }, [success, userIds, searchParams, dispatch, schoolId]);
}
